import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { FormGroup, FormControl } from '@angular/forms';
import { Cobradores } from 'app/entities/cobranza';
import { CarteraService } from 'app/services/cartera/cartera.service';

@Component({
  selector: 'app-update-cobrador',
  templateUrl: './update-cobrador.component.html',
  styleUrls: ['./update-cobrador.component.scss']
})
export class UpdateCobradorComponent implements OnInit {

  newForm: FormGroup;
  public cobradores: Array<Cobradores> = [];

  /**
   * Constructor
   * 
   * @param _data 
   * @param {CarteraService} _cartera 
   * @param {MatDialogRef<UpdateCobradorComponent>} dialog 
   * @param {MatSnackBar} _snackBar 
   */
  constructor
  (
    @Inject(MAT_DIALOG_DATA) private _data,
    private _cartera: CarteraService,
    public dialog: MatDialogRef<UpdateCobradorComponent>,
    private _snackBar: MatSnackBar
  ) 
  {
    this.newForm = this.createForm();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {
    // Servicio: Traer Cobradores
    this._cartera.VerCobradores().subscribe((data: Array<any>) => {
      data.forEach((element, i) => {
        this.cobradores[i] = {
          codigo: element.documento_usuario,
          nombre: element.nombre_completo
        }
      });
    });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Creación FormGroup
   * @returns {FormGroup}
   */
  createForm(): FormGroup {
    return new FormGroup({
      cobrador: new FormControl(this._data.ID_Cobrador)
    });
  }

  /**
   * Actualiza el cobrador, mediante los datos recibidos del componente padre
   * @param {any} form 
   */
  public actualizarCobrador(form: any): void{
    //Formato Año-Mes-Dia a la fecha que viene por MAT_DIALOG_DATA
    const Fecha_Cobro: string = this._data.FechaCobro.slice(0, 10);
    
    this._cartera.ActualizarCobrador(Fecha_Cobro, this._data.ID_Grupo, this._data.ID_Cobro, form)
                  .subscribe((data: any) => {
                    // Condición: Si existen filas afectadas, muestra mensaje de éxito y cierra modal, de lo contrario, muestra mensaje de error
                    if(data['affectedRows'] > 0){
                      this._snackBar.open('Cobrador Actualizado', 'Aceptar', {
                        duration: 2000
                      }); 
                      this.dialog.close(true);
                    }else{
                      this._snackBar.open('Error al actualizar el cobrador', '', {
                        duration: 2500,
                        panelClass: ['warn-600']
                      });
                    }
                  });
  }
}
